import { Controller } from "@hotwired/stimulus"

// Recherche instantanée + raccourci "aller à" sur la liste des marques,
// pour éviter de devoir scroller toute la grille pour trouver une marque.
export default class extends Controller {
  static targets = ["search", "jump", "card", "emptyMsg"]

  filterByText() {
    const q = this.searchTarget.value.trim().toLowerCase()
    let visibleCount = 0

    this.cardTargets.forEach((card) => {
      const name = (card.dataset.brandName || "").toLowerCase()
      const matches = q.length === 0 || name.includes(q)
      card.hidden = !matches
      if (matches) visibleCount++
    })

    if (this.hasEmptyMsgTarget) this.emptyMsgTarget.hidden = visibleCount > 0
  }

  jumpTo() {
    const id = this.jumpTarget.value
    if (!id) return

    const el = document.getElementById(id)
    if (el) {
      // S'assure que la carte visée n'est pas masquée par un filtre texte en cours
      if (this.hasSearchTarget) this.searchTarget.value = ""
      this.filterByText()

      el.scrollIntoView({ behavior: "smooth", block: "center" })
      el.classList.add("admin-brand-highlight")
      setTimeout(() => el.classList.remove("admin-brand-highlight"), 1600)
    }
    this.jumpTarget.value = ""
  }
}
